/** Dashboard theme — localStorage key matches `mira.theme` in settings schema. */
export const THEME_STORAGE_KEY = "mira.theme";

export type ThemeChoice = "light" | "dark";

export const THEME_BOOT_SCRIPT = `(function(){try{var t=localStorage.getItem(${JSON.stringify(THEME_STORAGE_KEY)});if(t!=="light"&&t!=="dark")t=window.matchMedia("(prefers-color-scheme: dark)").matches?"dark":"light";var el=document.documentElement;el.setAttribute("data-theme",t);el.classList.toggle("dark",t==="dark");el.style.colorScheme=t;}catch(e){var el=document.documentElement;el.setAttribute("data-theme","light");el.classList.remove("dark");el.style.colorScheme="light";}})();`;

export function applyTheme(theme: ThemeChoice): void {
  const el = document.documentElement;
  el.setAttribute("data-theme", theme);
  el.classList.toggle("dark", theme === "dark");
  el.style.colorScheme = theme;
  document.body?.setAttribute("data-theme", theme);
  try {
    localStorage.setItem(THEME_STORAGE_KEY, theme);
  } catch {
    /* private mode */
  }
}

export function readStoredTheme(): ThemeChoice {
  try {
    const t = localStorage.getItem(THEME_STORAGE_KEY);
    if (t === "light" || t === "dark") return t;
  } catch {
    /* private mode */
  }
  if (typeof window === "undefined") return "light";
  return window.matchMedia("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";
}

export function readDomTheme(): ThemeChoice {
  if (typeof document === "undefined") return "light";
  return document.documentElement.getAttribute("data-theme") === "dark"
    ? "dark"
    : "light";
}
